import { render } from "./DrSomaiyaSultana.vue?vue&type=template&id=2f7935b3"
import script from "./DrSomaiyaSultana.vue?vue&type=script&lang=js"
export * from "./DrSomaiyaSultana.vue?vue&type=script&lang=js"

import "./DrSomaiyaSultana.vue?vue&type=style&index=0&id=2f7935b3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__